import React from 'react';
import { motion } from 'framer-motion';
import './QuoteSection.css';
// Import your couple photo from assets
import coupleImg from '../assets/4.jpeg';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};

const contentVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
    },
  },
};

const QuoteSection = () => {
    return (
        <motion.div 
            id="quote-section"
            className="quote-container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={containerVariants}
        >
            <div className="image-wrapper">
                <img src={coupleImg} alt="Oshini and Dinendra" className="hover-image" />
                <motion.div 
                    className="overlay-content"
                    variants={contentVariants}
                >
                    <p className="quote-text">
                        "I have found the one my soul loves"
                    </p>
                    <p className="quote-source">SONG OF SOLOMON 3:4</p>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default QuoteSection;
